var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_c('i',{staticClass:"fa fa-spin fa-spinner fs-1"}),_vm._v(" Loading...")])])
}]

export { render, staticRenderFns }